import React, { useState, useEffect, useRef, useLayoutEffect } from "react";
// eslint-disable-next-line
import { Link, Route, Routes, useParams, useLocation } from "react-router-dom";

import { Tooltip as ReactTooltip } from "react-tooltip";

import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";

import axios from "axios";

import uploadImg from "./assets/upload.png";
// eslint-disable-next-line
import {
  getDownloadURL,
  listAll,
  ref,
  uploadBytes,
  uploadBytesResumable,
  getStorage,
  deleteObject,
} from "@firebase/storage";
import { v4 } from "uuid";
// eslint-disable-next-line

// eslint-disable-next-line
import { auth, firebase, imageDb } from "../Firebase/config";
// eslint-disable-next-line
import {
  onSnapshot,
  orderBy,
  limit,
  collection,
  addDoc,
  query,
  where,
  getDocs,
  deleteDoc,
  doc,
  setDoc,
  getDoc,
  updateDoc,
  arrayUnion,
  FieldValue,
  getCountFromServer,
} from "@firebase/firestore";
import NavBar from "./Navbar";

import "./Messages.css";

const isVideoUrl = (u) =>
  typeof u === "string" && !!u.match(/\.(mp4|webm|ogg|mov)(\?.*)?$/i);

const isVideoFile = (fileOrName) => {
  if (!fileOrName) return false;
  if (fileOrName instanceof File || (fileOrName && fileOrName.type)) {
    return (fileOrName.type || "").startsWith("video/");
  }
  return typeof fileOrName === "string" && !!fileOrName.match(/\.(mp4|webm|ogg|mov)$/i);
};

// memoized renderer — stable across renders so it won't remount when App re-renders
// ...existing code...
const MediaRenderer = React.memo(
  ({ src, fileName, style, alt, poster }) => {
    const actualSrc = Array.isArray(src) ? src[0] : src;
    const actualName = Array.isArray(fileName) ? fileName[0] : fileName;
    const [imgFailed, setImgFailed] = useState(false);

    if (!actualSrc) return null;

    const looksLikeVideo = isVideoUrl(actualSrc) || isVideoFile(actualName);

    if (looksLikeVideo) {
      return (
        <video
          src={actualSrc}
          controls
          playsInline
          preload="metadata"
          poster={poster}
          style={style}
          controlsList="nodownload"
          aria-label={alt || "video"}
        >
          Your browser does not support the video tag.
        </video>
      );
    }

    if (!imgFailed) {
      return (
        <img
          src={actualSrc}
          style={style}
          alt={alt || ""}
          onError={() => setImgFailed(true)}
        />
      );
    }

    return (
      <video
        src={actualSrc}
        controls
        playsInline
        preload="metadata"
        poster={poster}
        style={style}
        controlsList="nodownload"
        aria-label={alt || "video"}
      >
        Your browser does not support the video tag.
      </video>
    );
  },
  (prev, next) => {
    const norm = (v) => {
      if (Array.isArray(v)) return v[0];
      if (!v) return "";
      // If it's a File object use its name
      if (typeof File !== "undefined" && v instanceof File) return v.name || "";
      // If it's an object with a name property (e.g. File-like)
      if (typeof v === "object" && v.name) return v.name;
      return v;
    };
    const prevSrc = String(norm(prev.src) ?? "");
    const nextSrc = String(norm(next.src) ?? "");
    const prevName = String(norm(prev.fileName) ?? "");
    const nextName = String(norm(next.fileName) ?? "");
    const prevWidth = String(prev.style?.width ?? "");
    const nextWidth = String(next.style?.width ?? "");

    return (
      prevSrc === nextSrc &&
      prevName === nextName &&
      prev.alt === next.alt &&
      prev.poster === next.poster &&
      prevWidth === nextWidth
    );
  }
);
// ...existing code...

//with teacher access

//   http://localhost:3000/view/id/VO9zbrZ6czMhZTqwGkfBBEjH2CD2/only2studentid/kK8E2a6D8ehgGV3tXk22vkMFV3Z2/classid/qBQ5dp9aCn5cP8EcoTur/language/en

//   http://localhost:3000/view/id/VO9zbrZ6czMhZTqwGkfBBEjH2CD2/studentid/kK8E2a6D8ehgGV3tXk22vkMFV3Z2/classid/qBQ5dp9aCn5cP8EcoTur/language/en

//video production

// http://localhost:3000/view/id/VO9zbrZ6czMhZTqwGkfBBEjH2CD2/only2studentid/lvptnjVxRnc7SbopSHjsBzMZwyn2/classid/G4im8t2xtrLQB08kU3PV/language/en

//DlCS only changed class

// http://localhost:3000/view/id/VO9zbrZ6czMhZTqwGkfBBEjH2CD2/only2studentid/lvptnjVxRnc7SbopSHjsBzMZwyn2/classid/2xe9JuCLvzuNkhm8Qy8a/language/en

//without teacher access

//for Video Production

//   http://localhost:3000/studentid/lvptnjVxRnc7SbopSHjsBzMZwyn2/classid/G4im8t2xtrLQB08kU3PV/language/en

//   http://localhost:3000/studentid/kK8E2a6D8ehgGV3tXk22vkMFV3Z2/classid/qBQ5dp9aCn5cP8EcoTur/language/en

//   http://localhost:3000/only2studentid/kK8E2a6D8ehgGV3tXk22vkMFV3Z2/classid/qBQ5dp9aCn5cP8EcoTur/language/en

function App() {


  const location = useLocation();
  const importedObject = location.state?.aboutobjectofclass;
  const isAboutPage = location.pathname.includes("About");
  // eslint-disable-line no-unused-vars
  // eslint-disable-next-line
  const { only2studentid, studentid, classid, language, id, role } = useParams();

  const showReminderTimeout = useRef();
  console.log(studentid);
  // eslint-disable-next-line

  const [viewparentpage, setViewparentpage] = useState(true);
  // eslint-disable-next-line
  const [filetype, setFiletype] = useState();
  // eslint-disable-next-line

  const [teacher, setTeacher] = useState();
  const [classs, setClasss] = useState();
  // eslint-disable-next-line
  const [student, setStudent] = useState();


  const [bulletinarray, setBulletinarray] = useState([]);

  // Donotshow is used to show the toggle icon that is only worth showing to teachers on the About page. So it is true everywhere but on about page.
  const [donotshow, setDonotshow] = useState();

  const [viewteachersection, setViewteachersection] = useState(false);
  const [viewclasssection, setViewclasssection] = useState(false);
  const [viewbulletinsection, setViewbulletinsection] = useState(false);

  const [viewteachersection2, setViewteachersection2] = useState();
  const [viewclasssection2, setViewclasssection2] = useState();

  const [viewclasssection2x, setViewclasssection2x] = useState();
  const [viewclasssection2y, setViewclasssection2y] = useState();

  const [viewbulletinsection2, setViewbulletinsection2] = useState();

  const [entryheading, setEntryheading] = useState();
  const [entryurl, setEntryurl] = useState();
  const [entrydescription, setEntrydescription] = useState();

  const [selectedentry, setSelectedentry] = useState();

  const [localurl, setLocalurl] = useState([]);
  const [localtitle, setLocaltitle] = useState();
  const [localdescription, setLocaldescription] = useState();
  const [localid, setLocalid] = useState();
  const [bulletinentrynumber, setBulletinentrynumber] = useState();

  const [newtitletobesaved, setNewtitletobesaved] = useState("");
  const [newphotostobesaved, setNewphotostobesaved] = useState();
  const [newdescriptiontobesaved, setNewdescriptiontobesaved] = useState("");

  const [totalnumberofimages, setTotalnumberofimages] = useState();
  const [totalnumberofimages2, setTotalnumberofimages2] = useState();
  const [totalnumberofimages3, setTotalnumberofimages3] = useState();
  const [totalnumberofimages4, setTotalnumberofimages4] = useState(0);

  const [img, setImg] = useState("");
  const [img2, setImg2] = useState("");
  const [img3, setImg3] = useState("");
  const [img4, setImg4] = useState("");

  const [nameofimg, setNaeofimg] = useState();
  const [nameofimg2, setNaeofimg2] = useState();
  const [nameofimg3, setNaeofimg3] = useState();
  const [nameofimg4, setNaeofimg4] = useState();

  const [scrollablenumber, setScrollablenummber] = useState(0);
  const [scrollablenumber2, setScrollablenummber2] = useState(0);

  const [scrollablenumber3, setScrollablenummber3] = useState(0);
  const [scrollablenumber4, setScrollablenummber4] = useState(0);

  const [scrollablenumber5, setScrollablenummber5] = useState(0);
  const [scrollablenumber6, setScrollablenummber6] = useState(0);

  const [scrollablenumber7, setScrollablenummber7] = useState(0);
  const [scrollablenumber8, setScrollablenummber8] = useState(0);
  const [scrollablenumber9, setScrollablenummber9] = useState(0);
  const [scrollablenumber10, setScrollablenummber10] = useState(0);

  const [imgUrl, setImgUrl] = useState([]);

  const [localimg, setLocalimg] = useState();
  const [localimg2, setLocalimg2] = useState();
  const [localimg3, setLocalimg3] = useState();
  const [localimg4, setLocalimg4] = useState();
  const [makeentryactivex, setMakeentryactivex] = useState();


  const [makenewentryactive, setMakenewentryactive] = useState(true);

  const [newtitle, setNewtitle] = useState();

  const [refresh, setRefresh] = useState(true);

  const [isOpen1, setIsOpen1] = useState(false);
  const [isOpen2, setIsOpen2] = useState(false);
  const [isOpen3, setIsOpen3] = useState(false);
  const [isOpen3b, setIsOpen3b] = useState(false);
  const [isOpen4, setIsOpen4] = useState(false);
  const [isOpen5, setIsOpen5] = useState(false);
  const [isOpen5b, setIsOpen5b] = useState(false);
  const [isOpen6, setIsOpen6] = useState(false);
  const [isOpen8, setIsOpen8] = useState(false);
  const [isOpen9, setIsOpen9] = useState(false);
  const [isOpen10, setIsOpen10] = useState(false);
  const [isOpen11, setIsOpen11] = useState(false);

  const [isOpen12, setIsOpen12] = useState(false);
  const [isOpen13, setIsOpen13] = useState(false);
  const [isOpen14, setIsOpen14] = useState(false);
  const [isOpen15, setIsOpen15] = useState(false);
  const [isOpen16, setIsOpen16] = useState(false);
  const [isOpen17, setIsOpen17] = useState(false);

  const [isOpen18, setIsOpen18] = useState(false);
  const [isOpen19, setIsOpen19] = useState(false);

  const [isOpen20, setIsOpen20] = useState(false);
  const [isOpen21, setIsOpen21] = useState(false);

  const [isOpen22, setIsOpen22] = useState(false);
  const [isOpen23, setIsOpen23] = useState(false);

  const [isOpen24, setIsOpen24] = useState(false);
  const [isOpen25, setIsOpen25] = useState(false);

  const [studentidlocal, setstudentidlocal] = useState();

  const [maxwidthforweb, setMaxwidthforweb] = useState();

  const [newwidth, setNewwidth] = useState();

  const [showreminder, setShowreminder] = useState(false);

  const [text0, setText0] = useState("");
  const [text1, setText1] = useState("");
  const [text2, setText2] = useState("");
  const [text3, setText3] = useState("");
  const [text4, setText4] = useState("");

  const [text50, setText50] = useState("");
  const [text51, setText51] = useState("");
  const [text52, setText52] = useState("");
  const [text53, setText53] = useState("");
  const [text54, setText54] = useState("");
  const [text55, setText55] = useState("");
  const [text56, setText56] = useState("");
  const [text57, setText57] = useState("");
  const [text58, setText58] = useState("");
  const [text59, setText59] = useState("");

  const [text60, setText60] = useState("");
  const [text61, setText61] = useState("");
  const [text62, setText62] = useState("");
  const [text63, setText63] = useState("");
  const [text64, setText64] = useState("");
  const [text65, setText65] = useState("");
  const [text66, setText66] = useState("");
  const [text67, setText67] = useState("");
  const [text68, setText68] = useState("");
  const [text69, setText69] = useState("");

  const [filtereddata, setFiltereddata] = useState();

  const [getindex, setGetindex] = useState();

  const [temptitle, setTemptitle] = useState();
  const [tempdescription, setTempdescription] = useState();

  const [showbulletinsectionentryform, setShowbulletinsectionentryform] =
    useState(false);

  const [listofclasses, setListofclasses] = useState();

  const [counter, setCounter] = useState();
  const [counterx, setCounterx] = useState();
  const [countery, setCountery] = useState();
  const [counter2, setCounter2] = useState();
  const [counter3, setCounter3] = useState();
  const [counter3x, setCounter3x] = useState();

  const [counter5, setCounter5] = useState();

  const [temparray, setTemparray] = useState();
  const [temparray2, setTemparray2] = useState();

  const [temparray5, setTemparray5] = useState();
  const [temparray25, setTemparray25] = useState();

  const [bringinmenu2, setBringinmenu2] = useState(false);

  const [isLinkModalOpen, setIsLinkModalOpen] = useState(false);
  const [linkModalTarget, setLinkModalTarget] = useState("local"); // "local" or "new"
  const [linkFrontText, setLinkFrontText] = useState("");
  const [linkHref, setLinkHref] = useState("");

  const [aboutobjectofclass, setAboutobjectofclass] = useState();


  useEffect(() => {
    const stored = localStorage.getItem("aboutobjectofclass");
    if (stored) {
      try {
        setAboutobjectofclass(JSON.parse(stored));
      } catch (e) {
        localStorage.removeItem("aboutobjectofclass");
      }
    }
  }, []);


  useEffect(() => {
    if (typeof language != "undefined" && language != "en") {
      getnewlanguaage0();
      getnewlanguaage1();
      getnewlanguaage2();
    }
  }, [language]);

  useEffect(() => {
    // Only run on initial mount: accept only an array payload
    if (importedObject && Array.isArray(importedObject.bulletinarray)) {
      console.log("Setting bulletinarray from imported object");
      setBulletinarray(importedObject.bulletinarray);
    }
  }, []);  // Empty dependency array means this runs once on mount

  // Modify the existing useEffect that depends on id to check if bulletinarray is still needed

  useEffect(() => {

    if (typeof id !== "undefined" && Array.isArray(bulletinarray) && bulletinarray.length === 0) {
      console.log("Running backup data fetch with getadjustment()");
      getadjustment();
    }
  }, [id, bulletinarray]);



  const getadjustment = () => {
    if (!id) return;
    const docRef = doc(firebase, "users", id);
    getDoc(docRef).then((docSnap) => {
      const object = docSnap.data() || {};
      // Accept only arrays; fallback to empty array
      setBulletinarray(Array.isArray(object.bulletinarray) ? object.bulletinarray : []);
    }).catch((err) => {
      console.error("getadjustment error:", err);
    });
  };


  useEffect(() => {
    console.log("1");
    if (typeof language !== "undefined" && language !== "en" && Array.isArray(bulletinarray)) {
      console.log("2");
      setFiltereddata(bulletinarray);
    }
  }, [language, bulletinarray]);

  useEffect(() => {
    if (Array.isArray(filtereddata)) {
      console.log(filtereddata, "3");
    }
  }, [filtereddata]);

  const translateTextValue = async (value) => {
    const safeValue = String(value || "");

    if (!safeValue || typeof language === "undefined" || language === "en") {
      return safeValue;
    }

    const response = await axios.post(
      `https://translation.googleapis.com/language/translate/v2?key=AIzaSyC864hxQIdWZobAgG0RkMwhMNuxoWRYEPY`,
      {
        source: "en",
        format: "text",
        q: safeValue,
        target: language,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    return response.data.data.translations[0].translatedText;
  };

  const translateDescriptionPreservingLinks = async (description) => {
    const normalizedDescription = String(description || "").replaceAll(
      "{StudentName}",
      student || ""
    );
    const tokenPattern = /\{[^|{}]+\|([^|]+)\|([^}]+)\}/g;
    const segments = [];
    let lastIndex = 0;
    let match;

    while ((match = tokenPattern.exec(normalizedDescription)) !== null) {
      if (match.index > lastIndex) {
        segments.push({
          type: "text",
          value: normalizedDescription.slice(lastIndex, match.index),
        });
      }

      segments.push({
        type: "link",
        text: match[1],
        href: match[2],
      });

      lastIndex = tokenPattern.lastIndex;
    }

    if (lastIndex < normalizedDescription.length) {
      segments.push({
        type: "text",
        value: normalizedDescription.slice(lastIndex),
      });
    }

    if (segments.length === 0) {
      return translateTextValue(normalizedDescription);
    }

    const translatedSegments = await Promise.all(
      segments.map(async (segment) => {
        if (segment.type === "text") {
          return {
            ...segment,
            value: await translateTextValue(segment.value),
          };
        }

        return {
          ...segment,
          text: await translateTextValue(segment.text),
        };
      })
    );

    return translatedSegments
      .map((segment) =>
        segment.type === "text"
          ? segment.value
          : `{Link|${segment.text}|${segment.href}}`
      )
      .join("");
  };

  useEffect(() => {
    if (Array.isArray(filtereddata) && filtereddata.length > 0) {
      async function fetchData() {
        try {
          const response = await axios.post(
            `https://translation.googleapis.com/language/translate/v2?key=AIzaSyC864hxQIdWZobAgG0RkMwhMNuxoWRYEPY`,
            {
              source: "en",
              format: "text",
              q: filtereddata[0].Title,
              target: language,
            },
            {
              headers: {
                "Content-Type": "application/json",
              },
            }
          );

          setText50(response.data.data.translations[0].translatedText);
        } catch (error) {
          console.error("Error:", error);
        }
      }
      fetchData();

      async function fetchDatab() {
        try {
          const translatedDescription = await translateDescriptionPreservingLinks(
            filtereddata[0].Description
          );

          setText60(translatedDescription);
        } catch (error) {
          console.error("Error:", error);
        }
      }
      fetchDatab();
    }

    if (Array.isArray(filtereddata) && filtereddata.length > 1) {
      async function fetchData2() {

        try {
          const response = await axios.post(
            `https://translation.googleapis.com/language/translate/v2?key=AIzaSyC864hxQIdWZobAgG0RkMwhMNuxoWRYEPY`,
            {
              source: "en",
              format: "text",
              q: filtereddata[1].Title,
              target: language,
            },
            {
              headers: {
                "Content-Type": "application/json",
              },
            }
          );

          setText51(response.data.data.translations[0].translatedText);
        } catch (error) {
          console.error("Error:", error);
        }
      }
      fetchData2();

      async function fetchData2b() {
        try {
          const translatedDescription = await translateDescriptionPreservingLinks(
            filtereddata[1].Description
          );

          setText61(translatedDescription);
        } catch (error) {
          console.error("Error:", error);
        }
      }
      fetchData2b();
    }

    if (Array.isArray(filtereddata) && filtereddata.length > 2) {
      async function fetchData3() {
        try {
          const response = await axios.post(
            `https://translation.googleapis.com/language/translate/v2?key=AIzaSyC864hxQIdWZobAgG0RkMwhMNuxoWRYEPY`,
            {
              source: "en",
              format: "text",
              q: filtereddata[2].Title,
              target: language,
            },
            {
              headers: {
                "Content-Type": "application/json",
              },
            }
          );

          setText52(response.data.data.translations[0].translatedText);
        } catch (error) {
          console.error("Error:", error);
        }
      }
      fetchData3();

      async function fetchData3b() {
        try {
          const translatedDescription = await translateDescriptionPreservingLinks(
            filtereddata[2].Description
          );

          setText62(translatedDescription);
        } catch (error) {
          console.error("Error:", error);
        }
      }
      fetchData3b();
    }

    if (Array.isArray(filtereddata) && filtereddata.length > 3) {
      async function fetchData4() {
        try {
          const response = await axios.post(
            `https://translation.googleapis.com/language/translate/v2?key=AIzaSyC864hxQIdWZobAgG0RkMwhMNuxoWRYEPY`,
            {
              source: "en",
              format: "text",
              q: filtereddata[3].Title,
              target: language,
            },
            {
              headers: {
                "Content-Type": "application/json",
              },
            }
          );

          setText53(response.data.data.translations[0].translatedText);
        } catch (error) {
          console.error("Error:", error);
        }
      }
      fetchData4();

      async function fetchData4b() {
        try {
          const translatedDescription = await translateDescriptionPreservingLinks(
            filtereddata[3].Description
          );

          setText63(translatedDescription);
        } catch (error) {
          console.error("Error:", error);
        }
      }
      fetchData4b();
    }

    if (Array.isArray(filtereddata) && filtereddata.length > 4) {
      async function fetchData5() {
        try {
          const response = await axios.post(
            `https://translation.googleapis.com/language/translate/v2?key=AIzaSyC864hxQIdWZobAgG0RkMwhMNuxoWRYEPY`,
            {
              source: "en",
              format: "text",
              q: filtereddata[4].Title,
              target: language,
            },
            {
              headers: {
                "Content-Type": "application/json",
              },
            }
          );

          setText54(response.data.data.translations[0].translatedText);
        } catch (error) {
          console.error("Error:", error);
        }
      }
      fetchData5();

      async function fetchData5b() {
        try {
          const translatedDescription = await translateDescriptionPreservingLinks(
            filtereddata[4].Description
          );

          setText64(translatedDescription);
        } catch (error) {
          console.error("Error:", error);
        }
      }
      fetchData5b();
    }

    if (Array.isArray(filtereddata) && filtereddata.length > 5) {
      async function fetchData6() {
        try {
          const response = await axios.post(
            `https://translation.googleapis.com/language/translate/v2?key=AIzaSyC864hxQIdWZobAgG0RkMwhMNuxoWRYEPY`,
            {
              source: "en",
              format: "text",
              q: filtereddata[5].Title,
              target: language,
            },
            {
              headers: {
                "Content-Type": "application/json",
              },
            }
          );

          setText55(response.data.data.translations[0].translatedText);
        } catch (error) {
          console.error("Error:", error);
        }
      }
      fetchData6();

      async function fetchData6b() {
        try {
          const translatedDescription = await translateDescriptionPreservingLinks(
            filtereddata[5].Description
          );

          setText65(translatedDescription);
        } catch (error) {
          console.error("Error:", error);
        }
      }
      fetchData6b();
    }

    if (Array.isArray(filtereddata) && filtereddata.length > 6) {
      async function fetchData7() {
        try {
          const response = await axios.post(
            `https://translation.googleapis.com/language/translate/v2?key=AIzaSyC864hxQIdWZobAgG0RkMwhMNuxoWRYEPY`,
            {
              source: "en",
              format: "text",
              q: filtereddata[6].Title,
              target: language,
            },
            {
              headers: {
                "Content-Type": "application/json",
              },
            }
          );

          setText56(response.data.data.translations[0].translatedText);
        } catch (error) {
          console.error("Error:", error);
        }
      }
      fetchData7();

      async function fetchData7b() {
        try {
          const translatedDescription = await translateDescriptionPreservingLinks(
            filtereddata[6].Description
          );

          setText66(translatedDescription);
        } catch (error) {
          console.error("Error:", error);
        }
      }
      fetchData7b();
    }

    if (Array.isArray(filtereddata) && filtereddata.length > 7) {
      async function fetchData8() {
        try {
          const response = await axios.post(
            `https://translation.googleapis.com/language/translate/v2?key=AIzaSyC864hxQIdWZobAgG0RkMwhMNuxoWRYEPY`,
            {
              source: "en",
              format: "text",
              q: filtereddata[7].Title,
              target: language,
            },
            {
              headers: {
                "Content-Type": "application/json",
              },
            }
          );

          setText57(response.data.data.translations[0].translatedText);
        } catch (error) {
          console.error("Error:", error);
        }
      }
      fetchData8();

      async function fetchData8b() {
        try {
          const translatedDescription = await translateDescriptionPreservingLinks(
            filtereddata[7].Description
          );

          setText67(translatedDescription);
        } catch (error) {
          console.error("Error:", error);
        }
      }
      fetchData8b();
    }

    if (Array.isArray(filtereddata) && filtereddata.length > 8) {
      async function fetchData9() {
        try {
          const response = await axios.post(
            `https://translation.googleapis.com/language/translate/v2?key=AIzaSyC864hxQIdWZobAgG0RkMwhMNuxoWRYEPY`,
            {
              source: "en",
              format: "text",
              q: filtereddata[8].Title,
              target: language,
            },
            {
              headers: {
                "Content-Type": "application/json",
              },
            }
          );

          setText58(response.data.data.translations[0].translatedText);
        } catch (error) {
          console.error("Error:", error);
        }
      }
      fetchData9();

      async function fetchData9b() {
        try {
          const translatedDescription = await translateDescriptionPreservingLinks(
            filtereddata[8].Description
          );

          setText68(translatedDescription);
        } catch (error) {
          console.error("Error:", error);
        }
      }
      fetchData9b();
    }

    if (Array.isArray(filtereddata) && filtereddata.length > 9) {
      async function fetchData10() {
        try {
          const response = await axios.post(
            `https://translation.googleapis.com/language/translate/v2?key=AIzaSyC864hxQIdWZobAgG0RkMwhMNuxoWRYEPY`,
            {
              source: "en",
              format: "text",
              q: filtereddata[9].Title,
              target: language,
            },
            {
              headers: {
                "Content-Type": "application/json",
              },
            }
          );

          setText59(response.data.data.translations[0].translatedText);
        } catch (error) {
          console.error("Error:", error);
        }
      }
      fetchData10();

      async function fetchData10b() {
        try {
          const translatedDescription = await translateDescriptionPreservingLinks(
            filtereddata[9].Description
          );

          setText69(translatedDescription);
        } catch (error) {
          console.error("Error:", error);
        }
      }
      fetchData10b();
    }
  }, [filtereddata, language, student]);

  const getnewlanguaage0 = async () => {
    console.log(language, "2 the languge code");

    try {
      const response = await axios.post(
        `https://translation.googleapis.com/language/translate/v2?key=AIzaSyC864hxQIdWZobAgG0RkMwhMNuxoWRYEPY`,
        {
          source: "en",
          format: "text",
          q: "Currently Not Showing Anything",
          target: language,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      setText0(response.data.data.translations[0].translatedText);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const getnewlanguaage1 = async () => {
    console.log(language, "2 the languge code");

    try {
      const response = await axios.post(
        `https://translation.googleapis.com/language/translate/v2?key=AIzaSyC864hxQIdWZobAgG0RkMwhMNuxoWRYEPY`,
        {
          source: "en",
          format: "text",
          q: "About This Class",
          target: language,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      setText1(response.data.data.translations[0].translatedText);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const getnewlanguaage2 = async () => {
    console.log(language, "2 the languge code");

    try {
      const response = await axios.post(
        `https://translation.googleapis.com/language/translate/v2?key=AIzaSyC864hxQIdWZobAgG0RkMwhMNuxoWRYEPY`,
        {
          source: "en",
          format: "text",
          q: "About",
          target: language,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      setText2(response.data.data.translations[0].translatedText);
    } catch (error) {
      console.error("Error:", error);
    }
  };



  useEffect(() => {
    setMaxwidthforweb(1000);
  }, []);

  const storage = getStorage();

  useEffect(() => {
    if (isOpen1) {
      setIsOpen2(false);
      setIsOpen3(false);
      setIsOpen3b(false);
      setIsOpen4(false);
      setIsOpen5(false);
      setIsOpen5b(false);
      setIsOpen6(false);
      setIsOpen8(false);
      setIsOpen9(false);
      setIsOpen10(false);
      setIsOpen11(false);
      setIsOpen12(false);
      setIsOpen13(false);
      setIsOpen14(false);
      setIsOpen15(false);
      setIsOpen16(false);
      setIsOpen17(false);
      setIsOpen18(false);
      setIsOpen19(false);
      setIsOpen20(false);
      setIsOpen21(false);
      setIsOpen22(false);
      setIsOpen23(false);
      setIsOpen24(false);
      setIsOpen25(false);
    }
  }, [isOpen1]);

  useEffect(() => {
    if (isOpen2) {
      setIsOpen1(false);
      setIsOpen3(false);
      setIsOpen3b(false);
      setIsOpen4(false);
      setIsOpen5(false);
      setIsOpen5b(false);
      setIsOpen6(false);
      setIsOpen8(false);
      setIsOpen9(false);
      setIsOpen10(false);
      setIsOpen11(false);
      setIsOpen12(false);
      setIsOpen13(false);
      setIsOpen14(false);
      setIsOpen15(false);
      setIsOpen16(false);
      setIsOpen17(false);
      setIsOpen18(false);
      setIsOpen19(false);
      setIsOpen20(false);
      setIsOpen21(false);
      setIsOpen22(false);
      setIsOpen23(false);
      setIsOpen24(false);
      setIsOpen25(false);
    }
  }, [isOpen2]);

  useEffect(() => {
    if (isOpen3) {
      setIsOpen1(false);
      setIsOpen2(false);
      setIsOpen3b(false);
      setIsOpen4(false);
      setIsOpen5(false);
      setIsOpen5b(false);
      setIsOpen6(false);
      setIsOpen8(false);
      setIsOpen9(false);
      setIsOpen10(false);
      setIsOpen11(false);
      setIsOpen12(false);
      setIsOpen13(false);
      setIsOpen14(false);
      setIsOpen15(false);
      setIsOpen16(false);
      setIsOpen17(false);
      setIsOpen18(false);
      setIsOpen19(false);
      setIsOpen20(false);
      setIsOpen21(false);
      setIsOpen22(false);
      setIsOpen23(false);
      setIsOpen24(false);
      setIsOpen25(false);
    }
  }, [isOpen3]);

  useEffect(() => {
    if (isOpen3b) {
      setIsOpen1(false);
      setIsOpen2(false);
      setIsOpen3(false);
      setIsOpen4(false);
      setIsOpen5(false);
      setIsOpen5b(false);
      setIsOpen6(false);
      setIsOpen8(false);
      setIsOpen9(false);
      setIsOpen10(false);
      setIsOpen11(false);
      setIsOpen12(false);
      setIsOpen13(false);
      setIsOpen14(false);
      setIsOpen15(false);
      setIsOpen16(false);
      setIsOpen17(false);
      setIsOpen18(false);
      setIsOpen19(false);
      setIsOpen20(false);
      setIsOpen21(false);
      setIsOpen22(false);
      setIsOpen23(false);
      setIsOpen24(false);
      setIsOpen25(false);
    }
  }, [isOpen3b]);

  useEffect(() => {
    if (isOpen4) {
      setIsOpen1(false);
      setIsOpen2(false);
      setIsOpen3(false);
      setIsOpen3b(false);
      setIsOpen5(false);
      setIsOpen5b(false);
      setIsOpen6(false);
      setIsOpen8(false);
      setIsOpen9(false);
      setIsOpen10(false);
      setIsOpen11(false);
      setIsOpen12(false);
      setIsOpen13(false);
      setIsOpen14(false);
      setIsOpen15(false);
      setIsOpen16(false);
      setIsOpen17(false);
      setIsOpen18(false);
      setIsOpen19(false);
      setIsOpen20(false);
      setIsOpen21(false);
      setIsOpen22(false);
      setIsOpen23(false);
      setIsOpen24(false);
      setIsOpen25(false);
    }
  }, [isOpen4]);

  useEffect(() => {
    if (isOpen5) {
      setIsOpen1(false);
      setIsOpen2(false);
      setIsOpen3(false);
      setIsOpen3b(false);
      setIsOpen4(false);
      setIsOpen5b(false);
      setIsOpen6(false);
      setIsOpen8(false);
      setIsOpen9(false);
      setIsOpen10(false);
      setIsOpen11(false);
      setIsOpen12(false);
      setIsOpen13(false);
      setIsOpen14(false);
      setIsOpen15(false);
      setIsOpen16(false);
      setIsOpen17(false);
      setIsOpen18(false);
      setIsOpen19(false);
      setIsOpen20(false);
      setIsOpen21(false);
      setIsOpen22(false);
      setIsOpen23(false);
      setIsOpen24(false);
      setIsOpen25(false);
    }
  }, [isOpen5]);

  useEffect(() => {
    if (isOpen5b) {
      setIsOpen1(false);
      setIsOpen2(false);
      setIsOpen3(false);
      setIsOpen3b(false);
      setIsOpen4(false);
      setIsOpen5(false);
      setIsOpen6(false);
      setIsOpen8(false);
      setIsOpen9(false);
      setIsOpen10(false);
      setIsOpen11(false);
      setIsOpen12(false);
      setIsOpen13(false);
      setIsOpen14(false);
      setIsOpen15(false);
      setIsOpen16(false);
      setIsOpen17(false);
      setIsOpen18(false);
      setIsOpen19(false);
      setIsOpen20(false);
      setIsOpen21(false);
      setIsOpen22(false);
      setIsOpen23(false);
      setIsOpen24(false);
      setIsOpen25(false);
    }
  }, [isOpen5b]);

  useEffect(() => {
    if (isOpen6) {
      setIsOpen1(false);
      setIsOpen2(false);
      setIsOpen3(false);
      setIsOpen3b(false);
      setIsOpen4(false);
      setIsOpen5(false);
      setIsOpen5b(false);
      setIsOpen8(false);
      setIsOpen9(false);
      setIsOpen10(false);
      setIsOpen11(false);
      setIsOpen12(false);
      setIsOpen13(false);
      setIsOpen14(false);
      setIsOpen15(false);
      setIsOpen16(false);
      setIsOpen17(false);
      setIsOpen18(false);
      setIsOpen19(false);
      setIsOpen20(false);
      setIsOpen21(false);
      setIsOpen22(false);
      setIsOpen23(false);
      setIsOpen24(false);
      setIsOpen25(false);
    }
  }, [isOpen6]);

  useEffect(() => {
    if (isOpen8) {
      setIsOpen1(false);
      setIsOpen2(false);
      setIsOpen3(false);
      setIsOpen3b(false);
      setIsOpen4(false);
      setIsOpen5(false);
      setIsOpen5b(false);
      setIsOpen6(false);
      setIsOpen9(false);
      setIsOpen10(false);
      setIsOpen11(false);
      setIsOpen12(false);
      setIsOpen13(false);
      setIsOpen14(false);
      setIsOpen15(false);
      setIsOpen16(false);
      setIsOpen17(false);
      setIsOpen18(false);
      setIsOpen19(false);
      setIsOpen20(false);
      setIsOpen21(false);
      setIsOpen22(false);
      setIsOpen23(false);
      setIsOpen24(false);
      setIsOpen25(false);
    }
  }, [isOpen8]);

  useEffect(() => {
    if (isOpen9) {
      setIsOpen1(false);
      setIsOpen2(false);
      setIsOpen3(false);
      setIsOpen3b(false);
      setIsOpen4(false);
      setIsOpen5(false);
      setIsOpen5b(false);
      setIsOpen6(false);
      setIsOpen8(false);
      setIsOpen10(false);
      setIsOpen11(false);
      setIsOpen12(false);
      setIsOpen13(false);
      setIsOpen14(false);
      setIsOpen15(false);
      setIsOpen16(false);
      setIsOpen17(false);
      setIsOpen18(false);
      setIsOpen19(false);
      setIsOpen20(false);
      setIsOpen21(false);
      setIsOpen22(false);
      setIsOpen23(false);
      setIsOpen24(false);
      setIsOpen25(false);
    }
  }, [isOpen9]);

  useEffect(() => {
    if (isOpen9) {
      setIsOpen1(false);
      setIsOpen2(false);
      setIsOpen3(false);
      setIsOpen3b(false);
      setIsOpen4(false);
      setIsOpen5(false);
      setIsOpen5b(false);
      setIsOpen6(false);
      setIsOpen8(false);
      setIsOpen9(false);
      setIsOpen11(false);
      setIsOpen12(false);
      setIsOpen13(false);
      setIsOpen14(false);
      setIsOpen15(false);
      setIsOpen16(false);
      setIsOpen17(false);
      setIsOpen18(false);
      setIsOpen19(false);
      setIsOpen20(false);
      setIsOpen21(false);
      setIsOpen22(false);
      setIsOpen23(false);
      setIsOpen24(false);
      setIsOpen25(false);
    }
  }, [isOpen10]);

  useEffect(() => {
    if (isOpen9) {
      setIsOpen1(false);
      setIsOpen2(false);
      setIsOpen3(false);
      setIsOpen3b(false);
      setIsOpen4(false);
      setIsOpen5(false);
      setIsOpen5b(false);
      setIsOpen6(false);
      setIsOpen8(false);
      setIsOpen10(false);
      setIsOpen9(false);
      setIsOpen12(false);
      setIsOpen13(false);
      setIsOpen14(false);
      setIsOpen15(false);
      setIsOpen16(false);
      setIsOpen17(false);
      setIsOpen18(false);
      setIsOpen19(false);
      setIsOpen20(false);
      setIsOpen21(false);
      setIsOpen22(false);
      setIsOpen23(false);
      setIsOpen24(false);
      setIsOpen25(false);
    }
  }, [isOpen11]);

  useEffect(() => {
    if (isOpen9) {
      setIsOpen1(false);
      setIsOpen2(false);
      setIsOpen3(false);
      setIsOpen3b(false);
      setIsOpen4(false);
      setIsOpen5(false);
      setIsOpen5b(false);
      setIsOpen6(false);
      setIsOpen8(false);
      setIsOpen10(false);
      setIsOpen9(false);
      setIsOpen11(false);
      setIsOpen13(false);
      setIsOpen14(false);
      setIsOpen15(false);
      setIsOpen16(false);
      setIsOpen17(false);
      setIsOpen18(false);
      setIsOpen19(false);
      setIsOpen20(false);
      setIsOpen21(false);
      setIsOpen22(false);
      setIsOpen23(false);
      setIsOpen24(false);
      setIsOpen25(false);
    }
  }, [isOpen12]);

  useEffect(() => {
    if (isOpen9) {
      setIsOpen1(false);
      setIsOpen2(false);
      setIsOpen3(false);
      setIsOpen3b(false);
      setIsOpen4(false);
      setIsOpen5(false);
      setIsOpen5b(false);
      setIsOpen6(false);
      setIsOpen8(false);
      setIsOpen10(false);
      setIsOpen9(false);
      setIsOpen12(false);
      setIsOpen11(false);
      setIsOpen14(false);
      setIsOpen15(false);
      setIsOpen16(false);
      setIsOpen17(false);
      setIsOpen18(false);
      setIsOpen19(false);
      setIsOpen20(false);
      setIsOpen21(false);
      setIsOpen22(false);
      setIsOpen23(false);
      setIsOpen24(false);
      setIsOpen25(false);
    }
  }, [isOpen13]);

  useEffect(() => {
    if (isOpen9) {
      setIsOpen1(false);
      setIsOpen2(false);
      setIsOpen3(false);
      setIsOpen3b(false);
      setIsOpen4(false);
      setIsOpen5(false);
      setIsOpen5b(false);
      setIsOpen6(false);
      setIsOpen8(false);
      setIsOpen10(false);
      setIsOpen9(false);
      setIsOpen12(false);
      setIsOpen13(false);
      setIsOpen11(false);
      setIsOpen15(false);
      setIsOpen16(false);
      setIsOpen17(false);
      setIsOpen18(false);
      setIsOpen19(false);
      setIsOpen20(false);
      setIsOpen21(false);
      setIsOpen22(false);
      setIsOpen23(false);
      setIsOpen24(false);
      setIsOpen25(false);
    }
  }, [isOpen14]);

  useEffect(() => {
    if (isOpen9) {
      setIsOpen1(false);
      setIsOpen2(false);
      setIsOpen3(false);
      setIsOpen3b(false);
      setIsOpen4(false);
      setIsOpen5(false);
      setIsOpen5b(false);
      setIsOpen6(false);
      setIsOpen8(false);
      setIsOpen10(false);
      setIsOpen9(false);
      setIsOpen12(false);
      setIsOpen13(false);
      setIsOpen14(false);
      setIsOpen11(false);
      setIsOpen16(false);
      setIsOpen17(false);
      setIsOpen18(false);
      setIsOpen19(false);
      setIsOpen20(false);
      setIsOpen21(false);
      setIsOpen22(false);
      setIsOpen23(false);
      setIsOpen24(false);
      setIsOpen25(false);
    }
  }, [isOpen15]);

  useEffect(() => {
    if (isOpen9) {
      setIsOpen1(false);
      setIsOpen2(false);
      setIsOpen3(false);
      setIsOpen3b(false);
      setIsOpen4(false);
      setIsOpen5(false);
      setIsOpen5b(false);
      setIsOpen6(false);
      setIsOpen8(false);
      setIsOpen10(false);
      setIsOpen9(false);
      setIsOpen12(false);
      setIsOpen13(false);
      setIsOpen14(false);
      setIsOpen15(false);
      setIsOpen11(false);
      setIsOpen17(false);
      setIsOpen18(false);
      setIsOpen19(false);
      setIsOpen20(false);
      setIsOpen21(false);
      setIsOpen22(false);
      setIsOpen23(false);
      setIsOpen24(false);
      setIsOpen25(false);
    }
  }, [isOpen16]);

  useEffect(() => {
    if (isOpen9) {
      setIsOpen1(false);
      setIsOpen2(false);
      setIsOpen3(false);
      setIsOpen3b(false);
      setIsOpen4(false);
      setIsOpen5(false);
      setIsOpen5b(false);
      setIsOpen6(false);
      setIsOpen8(false);
      setIsOpen10(false);
      setIsOpen9(false);
      setIsOpen12(false);
      setIsOpen13(false);
      setIsOpen14(false);
      setIsOpen15(false);
      setIsOpen16(false);
      setIsOpen11(false);
      setIsOpen18(false);
      setIsOpen19(false);
      setIsOpen20(false);
      setIsOpen21(false);
      setIsOpen22(false);
      setIsOpen23(false);
      setIsOpen24(false);
      setIsOpen25(false);
    }
  }, [isOpen17]);

  useEffect(() => {
    if (isOpen9) {
      setIsOpen1(false);
      setIsOpen2(false);
      setIsOpen3(false);
      setIsOpen3b(false);
      setIsOpen4(false);
      setIsOpen5(false);
      setIsOpen5b(false);
      setIsOpen6(false);
      setIsOpen8(false);
      setIsOpen10(false);
      setIsOpen9(false);
      setIsOpen12(false);
      setIsOpen13(false);
      setIsOpen14(false);
      setIsOpen15(false);
      setIsOpen16(false);
      setIsOpen11(false);
      setIsOpen17(false);
      setIsOpen19(false);
      setIsOpen20(false);
      setIsOpen21(false);
      setIsOpen22(false);
      setIsOpen23(false);
      setIsOpen24(false);
      setIsOpen25(false);
    }
  }, [isOpen18]);

  useEffect(() => {
    if (isOpen9) {
      setIsOpen1(false);
      setIsOpen2(false);
      setIsOpen3(false);
      setIsOpen3b(false);
      setIsOpen4(false);
      setIsOpen5(false);
      setIsOpen5b(false);
      setIsOpen6(false);
      setIsOpen8(false);
      setIsOpen10(false);
      setIsOpen9(false);
      setIsOpen12(false);
      setIsOpen13(false);
      setIsOpen14(false);
      setIsOpen15(false);
      setIsOpen16(false);
      setIsOpen11(false);
      setIsOpen18(false);
      setIsOpen17(false);
      setIsOpen20(false);
      setIsOpen21(false);
      setIsOpen22(false);
      setIsOpen23(false);
      setIsOpen24(false);
      setIsOpen25(false);
    }
  }, [isOpen19]);

  useEffect(() => {
    if (isOpen9) {
      setIsOpen1(false);
      setIsOpen2(false);
      setIsOpen3(false);
      setIsOpen3b(false);
      setIsOpen4(false);
      setIsOpen5(false);
      setIsOpen5b(false);
      setIsOpen6(false);
      setIsOpen8(false);
      setIsOpen10(false);
      setIsOpen9(false);
      setIsOpen12(false);
      setIsOpen13(false);
      setIsOpen14(false);
      setIsOpen15(false);
      setIsOpen16(false);
      setIsOpen11(false);
      setIsOpen18(false);
      setIsOpen19(false);
      setIsOpen17(false);
      setIsOpen21(false);
      setIsOpen22(false);
      setIsOpen23(false);
      setIsOpen24(false);
      setIsOpen25(false);
    }
  }, [isOpen20]);

  useEffect(() => {
    if (isOpen9) {
      setIsOpen1(false);
      setIsOpen2(false);
      setIsOpen3(false);
      setIsOpen3b(false);
      setIsOpen4(false);
      setIsOpen5(false);
      setIsOpen5b(false);
      setIsOpen6(false);
      setIsOpen8(false);
      setIsOpen10(false);
      setIsOpen9(false);
      setIsOpen12(false);
      setIsOpen13(false);
      setIsOpen14(false);
      setIsOpen15(false);
      setIsOpen16(false);
      setIsOpen11(false);
      setIsOpen18(false);
      setIsOpen19(false);
      setIsOpen20(false);
      setIsOpen17(false);
      setIsOpen22(false);
      setIsOpen23(false);
      setIsOpen24(false);
      setIsOpen25(false);
    }
  }, [isOpen21]);

  useEffect(() => {
    if (isOpen9) {
      setIsOpen1(false);
      setIsOpen2(false);
      setIsOpen3(false);
      setIsOpen3b(false);
      setIsOpen4(false);
      setIsOpen5(false);
      setIsOpen5b(false);
      setIsOpen6(false);
      setIsOpen8(false);
      setIsOpen10(false);
      setIsOpen9(false);
      setIsOpen12(false);
      setIsOpen13(false);
      setIsOpen14(false);
      setIsOpen15(false);
      setIsOpen16(false);
      setIsOpen11(false);
      setIsOpen18(false);
      setIsOpen19(false);
      setIsOpen20(false);
      setIsOpen21(false);
      setIsOpen17(false);
      setIsOpen23(false);
      setIsOpen24(false);
      setIsOpen25(false);
    }
  }, [isOpen22]);

  useEffect(() => {
    if (isOpen9) {
      setIsOpen1(false);
      setIsOpen2(false);
      setIsOpen3(false);
      setIsOpen3b(false);
      setIsOpen4(false);
      setIsOpen5(false);
      setIsOpen5b(false);
      setIsOpen6(false);
      setIsOpen8(false);
      setIsOpen10(false);
      setIsOpen9(false);
      setIsOpen12(false);
      setIsOpen13(false);
      setIsOpen14(false);
      setIsOpen15(false);
      setIsOpen16(false);
      setIsOpen11(false);
      setIsOpen18(false);
      setIsOpen19(false);
      setIsOpen20(false);
      setIsOpen21(false);
      setIsOpen22(false);
      setIsOpen17(false);
      setIsOpen25(false);
    }
  }, [isOpen23]);

  useEffect(() => {
    if (isOpen9) {
      setIsOpen1(false);
      setIsOpen2(false);
      setIsOpen3(false);
      setIsOpen3b(false);
      setIsOpen4(false);
      setIsOpen5(false);
      setIsOpen5b(false);
      setIsOpen6(false);
      setIsOpen8(false);
      setIsOpen10(false);
      setIsOpen9(false);
      setIsOpen12(false);
      setIsOpen13(false);
      setIsOpen14(false);
      setIsOpen15(false);
      setIsOpen16(false);
      setIsOpen11(false);
      setIsOpen18(false);
      setIsOpen19(false);
      setIsOpen20(false);
      setIsOpen21(false);
      setIsOpen22(false);
      setIsOpen17(false);
      setIsOpen23(false);
      setIsOpen25(false);
    }
  }, [isOpen24]);

  useEffect(() => {
    if (isOpen9) {
      setIsOpen1(false);
      setIsOpen2(false);
      setIsOpen3(false);
      setIsOpen3b(false);
      setIsOpen4(false);
      setIsOpen5(false);
      setIsOpen5b(false);
      setIsOpen6(false);
      setIsOpen8(false);
      setIsOpen10(false);
      setIsOpen9(false);
      setIsOpen12(false);
      setIsOpen13(false);
      setIsOpen14(false);
      setIsOpen15(false);
      setIsOpen16(false);
      setIsOpen11(false);
      setIsOpen18(false);
      setIsOpen19(false);
      setIsOpen20(false);
      setIsOpen21(false);
      setIsOpen22(false);
      setIsOpen17(false);
      setIsOpen23(false);
      setIsOpen24(false);
    }
  }, [isOpen25]);



  useEffect(() => {
    if (showbulletinsectionentryform == false) {
      if (
        newtitletobesaved.length > 0 ||
        newdescriptiontobesaved.length > 0 ||
        (typeof newphotostobesaved != "undefined" && newphotostobesaved != "")
      ) {
        if (typeof newphotostobesaved != "undefined") {
          let bulletinentry = {
            Description: newdescriptiontobesaved,
            Title: newtitletobesaved,
            id: Date.now(),
            makeentryactive: true,
            url: newphotostobesaved,
          };

          updateDoc(doc(firebase, "users", id), {
            bulletinarray: arrayUnion(bulletinentry),
          }).catch((error) => {
            console.log(error);
            alert(error);
          });
          let array = bulletinarray;
          array.push(bulletinentry);

          setTimeout(() => {
            setBulletinarray(array);
            localStorage.setItem("bulletinarray", JSON.stringify(array));
          }, 5);

          setNewtitletobesaved("");
          setNewphotostobesaved(undefined);
          setNewdescriptiontobesaved("");
          setImg4("");
          setNaeofimg4(undefined);
          setLocalurl([]);

          // Exit entry form and return to view mode
          setShowbulletinsectionentryform(false);
          setViewbulletinsection(false);



        } else {
          let bulletinentry = {
            Description: newdescriptiontobesaved,
            Title: newtitletobesaved,
            id: Date.now(),
            makeentryactive: true,
            url: [],
          };

          updateDoc(doc(firebase, "users", id), {
            bulletinarray: arrayUnion(bulletinentry),
          }).catch((error) => {
            console.log(error);
            alert(error);
          });

          let array = bulletinarray;
          array.push(bulletinentry);

            setNewtitletobesaved("");
          setNewphotostobesaved(undefined);
          setNewdescriptiontobesaved("");
          setImg4("");
          setNaeofimg4(undefined);
          setLocalurl([]);

          // Exit entry form and return to view mode
          setShowbulletinsectionentryform(false);
          setViewbulletinsection(false);

          setTimeout(() => {
            setBulletinarray(array);
            localStorage.setItem("bulletinarray", JSON.stringify(array));
          }, 5);
        }
      }
    } else {
     console.log("No new entry to save");
    }
  }, [showbulletinsectionentryform]);


  useEffect(() => {
    if (typeof only2studentid != "undefined") {
      let teach = localStorage.getItem("nameofteacher");
      let clas = localStorage.getItem("nameofclass");
      let stud = localStorage.getItem("nameofstudent");

      setTeacher(teach);
      setClasss(clas);
      setStudent(stud);
    }

    if (typeof studentid != "undefined") {
      let teach = localStorage.getItem("nameofteacher");
      let clas = localStorage.getItem("nameofclass");
      let stud = localStorage.getItem("nameofstudent");

      setTeacher(teach);
      setClasss(clas);
      setStudent(stud);
    }
  }, [only2studentid, studentid]);


  useEffect(() => {
    setViewteachersection(false);
    setViewclasssection(false);
    setViewbulletinsection(false);
    setShowbulletinsectionentryform(false);
  }, [viewparentpage]);

  useEffect(() => {
    setIsOpen1(false);
    setIsOpen2(false);
    setIsOpen3(false);
    setIsOpen3b(false);
    setIsOpen4(false);
    setIsOpen5(false);
    setIsOpen5b(false);
    setIsOpen6(false);
    setIsOpen8(false);
    setIsOpen9(false);
    setIsOpen10(false);
    setIsOpen11(false);
    setIsOpen12(false);
    setIsOpen13(false);
    setIsOpen14(false);
    setIsOpen15(false);
    setIsOpen16(false);
    setIsOpen17(false);
    setIsOpen18(false);
    setIsOpen19(false);
    setIsOpen20(false);
    setIsOpen21(false);
    setIsOpen22(false);
    setIsOpen23(false);
    setIsOpen24(false);
    setIsOpen25(false);
  }, [
    viewparentpage,
    viewbulletinsection,
    donotshow,
    showbulletinsectionentryform
  ]);

  useEffect(() => {
    setScrollablenummber(0);
    setScrollablenummber2(0);
    setScrollablenummber3(0);
    setScrollablenummber4(0);
    setScrollablenummber5(0);
    setScrollablenummber6(0);
    setScrollablenummber7(0);
    setScrollablenummber8(0);
  }, [
    viewparentpage,
    viewbulletinsection,
  ]);

  const selectHandler = (value, i) => {
    setViewbulletinsection(true);

    setSelectedentry(value);

    setBulletinentrynumber(i);

    setTotalnumberofimages(1);
    console.log(i, "This is the Number of the Bulletin entry>");
  };

  const handleChange = (value) => {
    setLocaltitle(value);
  };

  const handleChange2 = (value) => {
    setLocaldescription(value);
  };

  const handleChange4 = (value) => {
    setNewdescriptiontobesaved(value);
  };

  const handleChange3 = (value) => {
    setNewtitletobesaved(value);
  };
  useEffect(() => {
    if (typeof selectedentry != "undefined") {
      setLocalid(selectedentry.id);
      setLocaldescription(selectedentry.Description);
      setLocalurl(selectedentry.url);
      setLocaltitle(selectedentry.Title);
      setMakeentryactivex(selectedentry.makeentryactive);
    }
  }, [selectedentry]);


  const beginwiththis = (entry) => {
    if (!Array.isArray(bulletinarray)) {
      console.warn("beginwiththis: bulletinarray is not an array");
      return;
    }
    setMakeentryactivex(false);
    console.log(entry, "this is the value that is brought up");
    setViewbulletinsection(false);

    const idx = bulletinarray.findIndex((v) => v.id === localid);
    if (idx === -1) return;
    // mutate safely (still using original pattern, but guarded)
    bulletinarray[idx].makeentryactive = false;

    try {
      localStorage.setItem("bulletinarray", JSON.stringify(bulletinarray));
    } catch (e) {
      console.warn("LocalStorage set failed:", e);
    }

    setTimeout(() => {
      updateDoc(doc(firebase, "users", id), { bulletinarray }).catch((error) => {
        console.log(error);
        alert(error);
      });
    }, 5);
  };

  const beginwiththis2 = (value) => {
    if (!Array.isArray(bulletinarray)) {
      console.warn("beginwiththis2: bulletinarray is not an array");
      return;
    }
    setMakeentryactivex(true);
    console.log(value, "this is the value that is brought up");
    setViewbulletinsection(false);

    const idx = bulletinarray.findIndex((v) => v.id === localid);
    if (idx === -1) return;
    bulletinarray[idx].makeentryactive = true;

    try {
      localStorage.setItem("bulletinarray", JSON.stringify(bulletinarray));
    } catch (e) {
      console.warn("LocalStorage set failed:", e);
    }

    setTimeout(() => {
      updateDoc(doc(firebase, "users", id), { bulletinarray }).catch((error) => {
        console.log(error);
        alert(error);
      });
    }, 5);
  };

  const addStudentname = (value) => {
    setLocaldescription(prev => (prev || "") + " {StudentName} ");
  };

  const addStudentnameToNewEntry = (value) => {
  setNewdescriptiontobesaved(prev => (prev || "") + " {StudentName} ");
};

  const addLink = (target = "local") => {
    setLinkModalTarget(target);
    setLinkFrontText("");
    setLinkHref("");
    setIsLinkModalOpen(true);
  };

  const addLinkToNewEntry = (target = "new") => {
  setLinkModalTarget(target);
  setLinkFrontText("");
  setLinkHref("");
  setIsLinkModalOpen(true);
};

  const saveLinkToDescription = () => {
    // basic validation
    if (!linkFrontText || !linkHref) {
      alert("Please provide both link text and URL.");
      return;
    }

    // token format used in saved description: {Link|frontText|href}
    const token = `{Link|${linkFrontText}|${linkHref}}`;

    if (linkModalTarget === "local") {
      setLocaldescription(prev => (prev || "") + " " + token + " ");
    } else {
      setNewdescriptiontobesaved(prev => (prev || "") + " " + token + " ");
    }

    setIsLinkModalOpen(false);
  };

  const renderDescriptionForDisplay = (desc) => {
    if (!desc && desc !== "") return null;
    const studentName = student || "";
    // replace StudentName tokens first
    const replaced = String(desc).replaceAll("{StudentName}", studentName);

    // Accept translated token headers too, e.g. {Lien|text|url}.
    const regex = /\{[^|{}]+\|([^|]+)\|([^}]+)\}/g;
    const parts = [];
    let lastIndex = 0;
    let match;
    let keyIndex = 0;

    while ((match = regex.exec(replaced)) !== null) {
      if (match.index > lastIndex) {
        parts.push(replaced.slice(lastIndex, match.index));
      }
      const text = match[1];
      const href = match[2];

      // ensure href is a valid-looking url; if not, prefix with http://
      const normalizedHref = /^(https?:)?\/\//i.test(href) ? href : `http://${href}`;

      parts.push(
        <a
          key={`link-${keyIndex++}`}
          href={normalizedHref}
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: "lightblue", textDecoration: "underline" }}
        >
          {text}
        </a>
      );

      lastIndex = regex.lastIndex;
    }

    if (lastIndex < replaced.length) {
      parts.push(replaced.slice(lastIndex));
    }

    // return as array of nodes (React can render this)
    return parts.map((p, i) =>
      typeof p === "string" ? <span key={`txt-${i}`}>{p}</span> : p
    );
  };



  useEffect(() => {
    if (viewbulletinsection == true) {
      setShowbulletinsectionentryform(false);
    }

    if (showbulletinsectionentryform == true) {
      setViewbulletinsection(false);
    }
  }, [
    viewbulletinsection,
    showbulletinsectionentryform,
  ]);

  async function submmitChange(value) {
    if (!Array.isArray(bulletinarray) || !selectedentry) {
      console.warn("submmitChange: invalid state");
      return;
    }
    console.log(value, "this is the value that is brought up");

    setTotalnumberofimages(Array.isArray(selectedentry.url) ? selectedentry.url.length : (selectedentry.url ? 1 : 0));
    setViewbulletinsection(false);

    const idx = bulletinarray.findIndex((v) => v.id === localid);
    if (idx === -1) return;
    bulletinarray[idx].Title = localtitle;
    bulletinarray[idx].url = selectedentry.url;
    bulletinarray[idx].Description = localdescription;

    try {
      localStorage.setItem("bulletinarray", JSON.stringify(bulletinarray));
    } catch (e) {
      console.warn("LocalStorage set failed:", e);
    }

    setTimeout(() => {
      updateDoc(doc(firebase, "users", id), { bulletinarray }).catch((error) => {
        console.log(error);
        alert(error);
      });
    }, 1000);
  }

  useEffect(() => {
    if (typeof temparray != "undefined") {
      console.log("This function abc");
      submmitChange2();
    }
  }, [temparray]);


  async function submmitChange2() {
    if (!Array.isArray(bulletinarray)) {
      console.warn("submmitChange2: bulletinarray is not an array");
      return;
    }

    // Validation 1: Check that at least one field is filled
    if (!localtitle && !localurl && !localdescription) {
      alert("Please fill in at least a title, image, or description before saving.");
      return;
    }

    // Validation 2: Check for duplicate entries (at least 2 of 3 elements match)
    const isDuplicate = bulletinarray.some((entry) => {
      let matchCount = 0;

      // Compare title
      if (localtitle && entry.Title && localtitle.trim().toLowerCase() === entry.Title.trim().toLowerCase()) {
        matchCount++;
      }

      // Compare image URL
      if (localurl && entry.url && localurl === entry.url) {
        matchCount++;
      }

      // Compare description
      if (localdescription && entry.Description && localdescription.trim().toLowerCase() === entry.Description.trim().toLowerCase()) {
        matchCount++;
      }

      // If at least 2 elements match, it's a duplicate
      return matchCount >= 2;
    });

    if (isDuplicate) {
      alert("⚠️ An entry with similar content already exists! (2 or more matching elements: title, image, or description)");
      return;
    }

    try {
      console.log("Saving new bulletin entry...");
      setTotalnumberofimages(Array.isArray(localurl) ? localurl.length : (localurl ? 1 : 0));

      const now = Date.now();
      const newobject = {
        Description: localdescription,
        Title: localtitle,
        url: localurl,
        id: now,
        makeentryactive: true,
      };

      // Add to local bulletinarray state
      const updatedBulletinArray = [...bulletinarray, newobject];
      setBulletinarray(updatedBulletinArray);

      // Save to localStorage
      try {
        localStorage.setItem("bulletinarray", JSON.stringify(updatedBulletinArray));
      } catch (e) {
        console.warn("LocalStorage set failed:", e);
      }

      // Save to Firestore
      await updateDoc(doc(firebase, "users", id), {
        bulletinarray: arrayUnion(newobject),
      });

      console.log("✅ Bulletin entry saved successfully!");

      // Reset form values
      setNewtitletobesaved("");
      setNewphotostobesaved(undefined);
      setNewdescriptiontobesaved("");
      setImg4("");
      setNaeofimg4(undefined);
      setLocalurl([]);

      // Exit entry form and return to view mode
      setShowbulletinsectionentryform(false);
      setViewbulletinsection(false);

      // Show success message
      alert("✅ Entry saved successfully! Form has been reset.");

    } catch (error) {
      console.error("❌ Error saving bulletin entry:", error);
      alert(`❌ Error saving entry: ${error.message || error}`);
    }
  }

  useEffect(() => {
    if (typeof only2studentid != "undefined") {
      setstudentidlocal(only2studentid);
    }
  }, [only2studentid]);

  useEffect(() => {
    if (typeof studentid != "undefined") {
      setstudentidlocal(studentid);
    }
  }, [studentid]);


  useEffect(() => {
    if (typeof studentid !== "undefined" || typeof only2studentid !== "undefined") {
      const teach = localStorage.getItem("nameofteacher");
      const clas = localStorage.getItem("nameofclass");
      const stud = localStorage.getItem("nameofstudent");

      setTeacher(teach);
      setClasss(clas);
      setStudent(stud);

      // Safely read bulletinarray from localStorage
      try {
        const parsed = JSON.parse(localStorage.getItem("bulletinarray"));
        setBulletinarray(Array.isArray(parsed) ? parsed : []);
      } catch (err) {
        console.warn("Failed to parse bulletinarray from localStorage:", err);
        setBulletinarray([]);
      }

      // classids may be null/invalid; parse carefully
      try {
        const classids = JSON.parse(localStorage.getItem("classids"));
        setListofclasses(classids);
      } catch (err) {
        console.warn("Failed to parse classids from localStorage:", err);
        setListofclasses(undefined);
      }
    }
  }, [only2studentid, studentid]);


  useEffect(() => {
    setDonotshow(false);
  }, []);

  useEffect(() => {
    if (typeof temparray5 != "undefined") {

      setCounter5(0);
    }
  }, [temparray5]);

  useEffect(() => {
    if (typeof counter5 != "undefined") {
      readytodelete();

    }
  }, [counter5]);

  async function readytodelete() {

    updateDoc(
      doc(firebase, "users", id),
      {
        bulletinarray: temparray5[counter5].bulletin,
      }
    )
      .catch((error) => {
        console.log(error);
        alert(error);
      })
      .then(async () => {
        if (counter5 < temparray5.length - 1) {
          setCounter5(counter5 + 1);
        } else {
          console.log("JJJ");
          setTemparray5();
          setCounter5();
          setViewbulletinsection(false);
          setSelectedentry();
          setBulletinentrynumber();
          setTotalnumberofimages();
        }
      });
  }

  const removeentry = (selectedentry) => {
    if (typeof selectedentry === "undefined" || !Array.isArray(bulletinarray)) return;

    // remove image later after all classes have gotten rid
    removeonneatatime();

    const filteredData = bulletinarray.filter((person) => person.id !== selectedentry.id);

    try {
      localStorage.setItem("bulletinarray", JSON.stringify(filteredData));
    } catch (e) {
      console.warn("LocalStorage set failed:", e);
    }

    setTimeout(() => {
      updateDoc(doc(firebase, "users", id), { bulletinarray: filteredData }).catch((error) => {
        console.log(error);
        alert(error);
      });
      try {
        localStorage.setItem("bulletinarray", JSON.stringify(filteredData));
      } catch (e) { }
    }, 5);

    setShowbulletinsectionentryform(false);
    setViewbulletinsection(false);
    setBulletinarray(filteredData);

    setTimeout(() => {
      setSelectedentry();
      setLocalid();
      setLocaldescription();
      setLocalurl();
      setLocaltitle();
      setMakeentryactivex();
    }, 1000);
    console.log("This is what we are going to remove");
  };


  const removeonneatatime = () => {

    if (typeof localurl != "undefined" && localurl != "" && localurl != []) {

      const desertRef = ref(storage, localurl);

      console.log(localurl, "THISS IS WHAT IS ABOUT TO GET deleeted")
      deleteObject(desertRef)
        .then(() => {
          console.log("the image got deleted");
        })
        .catch((error) => {
          console.log("the immage DaID NOT get deleted");
        });
    };

  }

  const DhandleClick2 = (i) => {
    if (img4 !== null) {
      const imgRef = ref(imageDb, `/FCMImages/${v4()}`);
      uploadBytes(imgRef, img4).then((value) => {
        console.log(value.ref, "444");
        getDownloadURL(value.ref)
          .then((url) => {
            if (typeof newphotostobesaved != "undefined") {
              setNewphotostobesaved(url);
              setTotalnumberofimages4(1);
            } else {
              setNewphotostobesaved(url);
              setTotalnumberofimages4(1);
            }
          })
          .then((url) => {
            setLocalimg4();
            setRefresh(!refresh);
            setNaeofimg4();
          });
      });
    }
  };


  // ...existing code...
  const handleClick2 = (i) => {
    console.log(i, "THis should be the localimg");
    if (img !== null) {
      const imgRef = ref(imageDb, `/FCMImages/${v4()}`);
      uploadBytes(imgRef, img).then((value) => {
        console.log(value.ref, "444");
        getDownloadURL(value.ref)
          .then((url) => {
            let array = url;
            setLocalurl(array);
            setImgUrl((data) => [...data, url]);

            // Guard bulletinarray before mutating
            if (Array.isArray(bulletinarray)) {
              const idx = bulletinarray.findIndex((v) => v.id === localid);
              if (idx !== -1) {
                bulletinarray[idx].url = array;
              }
            } else {
              console.warn("handleClick2: bulletinarray is not an array");
            }

            setTotalnumberofimages(1);

            setTimeout(() => {
              updateDoc(doc(firebase, "users", id), {
                bulletinarray: bulletinarray,
              }).catch((error) => {
                console.log(error);
                alert(error);
              });

              try {
                localStorage.setItem(
                  "bulletinarray",
                  JSON.stringify(bulletinarray)
                );
              } catch (e) {
                console.warn("LocalStorage set failed:", e);
              }
            }, 1000);
          })
          .then((url) => {
            setLocalimg();
            setRefresh(!refresh);
            setNaeofimg();
          });
      });
    }
  };
  // ...existing code...

  useEffect(() => {
    listAll(ref(imageDb, "/FCMImages")).then((imgs) => {
      console.log(imgs, "222");
      imgs.items.forEach((val) => {
        getDownloadURL(val).then((url) => {
          console.log(url, "333");
          setImgUrl((data) => [...data, url]);
        });
      });
    });
  }, []);


  const deleteimage27 = (yo) => {
    if (!yo) return;
    console.log("what is the image", yo);
    const desertRef = ref(storage, yo);

    setLocalurl("");
    if (Array.isArray(bulletinarray)) {
      const idx = bulletinarray.findIndex((v) => v.id === localid);
      if (idx !== -1) {
        bulletinarray[idx].url = "";
      }
    }
    setTotalnumberofimages(0);

    setTimeout(() => {
      console.log(bulletinarray, "this is the nested array");
      updateDoc(doc(firebase, "users", id), { bulletinarray }).catch((error) => {
        console.log(error);
        alert(error);
      });
      try {
        localStorage.setItem("bulletinarray", JSON.stringify(bulletinarray));
      } catch (e) { }
    }, 1000);

    // Delete the file
    deleteObject(desertRef)
      .then(() => {
        console.log("the image got deleted");
      })
      .then((url) => {
        setLocalimg();
        setRefresh((r) => !r);
        setNaeofimg();
      })
      .catch((error) => {
        alert("the image DID NOT get deleted");
      });
  };

  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;

    return {
      width,
      height,
    };
  }

  const useWindowDimensions = () => {
    const [windowDimensions, setWindowDimensions] = useState(
      getWindowDimensions()
    );

    useLayoutEffect(() => {
      function handleResize() {
        setWindowDimensions(getWindowDimensions());
      }

      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }, []);

    return windowDimensions;
  };

  const { height, width } = useWindowDimensions();

  useEffect(() => {
    if (width > maxwidthforweb) {
      setNewwidth(maxwidthforweb);
    } else {
      setNewwidth(width);
    }
  }, [width]);

  useEffect(() => {
    if (newwidth > maxwidthforweb) {
      setNewwidth(maxwidthforweb);
    }
  }, [newwidth]);

  const myImageStyle = { width: width };
  const imagewidth = newwidth / 2;

  useEffect(() => {
    if (!img) return;
    setNaeofimg(img.name);
    const objectUrl = URL.createObjectURL(img);
    setLocalimg(objectUrl);

    return () => {
      try {
        URL.revokeObjectURL(objectUrl);
      } catch (e) { }
      // only clear localimg if it still references this objectUrl
      setLocalimg(prev => (prev === objectUrl ? undefined : prev));
    };
  }, [img]);

  useEffect(() => {
    if (!img4) return;
    setNaeofimg4(img4.name);
    const objectUrl = URL.createObjectURL(img4);
    setLocalimg4(objectUrl);

    return () => {
      try {
        URL.revokeObjectURL(objectUrl);
      } catch (e) { }
      setLocalimg4(prev => (prev === objectUrl ? undefined : prev));
    };
  }, [img4]);

  useEffect(() => {
    // Clear any previous timeout
    if (showReminderTimeout.current) {
      clearTimeout(showReminderTimeout.current);
    }
    // Check if bulletinarray is an array
    if (Array.isArray(bulletinarray)) {
      const anyactive = bulletinarray.filter(item => item.makeentryactive === true).length;
      if (anyactive > 0) {
        setShowreminder(false);
      } else {
        showReminderTimeout.current = setTimeout(() => {
          setShowreminder(true);
        }, 3000);
      }
    } else {
      setShowreminder(false);
    }
    // Cleanup on unmount or dependency change
    return () => {
      if (showReminderTimeout.current) {
        clearTimeout(showReminderTimeout.current);
      }
    };
  }, [bulletinarray, viewparentpage]);



  // ...existing code...
  // ...existing code...

  return (
    <>
      <div className="App22">
        <NavBar
          viewparentpage={isAboutPage ? viewparentpage : null}
          setViewparentpage={isAboutPage ? setViewparentpage : null}
          donotshow={isAboutPage ? donotshow : null}
          aboutHasBulletinEntries={isAboutPage ? (Array.isArray(bulletinarray) && bulletinarray.length > 0) : null}
          bringinmenu2={isAboutPage ? bringinmenu2 : null}
          role={isAboutPage ? role : null}
          setBringinmenu2={isAboutPage ? setBringinmenu2 : null}
        />

        {typeof viewparentpage != "undefined" && viewparentpage === false ? (
          <div className="App" style={{ maxWidth: newwidth }} onClick={() => setBringinmenu2(!bringinmenu2)}>
            <header className="App-header">

              {showbulletinsectionentryform ==
                true ? null : typeof viewbulletinsection != "undefined" &&
                  showbulletinsectionentryform == false &&
                  bulletinarray.length < 10 ? (
                <div className="section591plus">
                  <p
                    className="section5922abplus"
                    onClick={() => setShowbulletinsectionentryform(true)}
                    data-tooltip-id="my-tooltip-1"
                    onMouseEnter={() => setIsOpen1(true)}
                    onMouseLeave={() => setIsOpen1(false)}
                  >
                    +
                  </p>
                </div>
              ) : showbulletinsectionentryform ==
                true ? null : typeof viewbulletinsection != "undefined" &&
                  showbulletinsectionentryform == false &&
                  bulletinarray.length > 9 ? (
                <div className="section591plus">
                  <p
                    className="section5922abplus"
                    onClick={() =>
                      alert("You have reached your limit of 10 entries.")
                    }
                    data-tooltip-id="my-tooltip-1"
                    onMouseEnter={() => setIsOpen1(true)}
                    onMouseLeave={() => setIsOpen1(false)}
                  >
                    +
                  </p>
                </div>
              ) : null}

              {showbulletinsectionentryform ==
                true ? null : viewbulletinsection === false &&
                  showbulletinsectionentryform == false ? (
                bulletinarray &&
                bulletinarray.map((dataVal, i) => {
                  return (
                    <div key={i}>
                      <p
                        className="section5922abicon"
                        data-tooltip-id="my-tooltip-4"
                        onClick={() => selectHandler(dataVal, i)}
                        onMouseEnter={() => setIsOpen4(true)}
                        onMouseLeave={() => setIsOpen4(false)}
                      >
                        ✏️
                      </p>

                      <div className="section591">
                        <p className="section5922abicon"> {dataVal.Title}</p>
                      </div>
                      {typeof dataVal.url != "undefined" &&
                        dataVal.url != "" ? (
                        <MediaRenderer
                          src={dataVal.url}
                          fileName={dataVal.url}
                          style={{ width: "65%" }}
                          alt="Accepted Files: .png, .jpeg, .jpg, .webp, .mp4, .gif, .mov"
                        />
                      ) : null}
                      <p
                        className="section5922a2345"
                        style={{ width: newwidth ? newwidth - 100 : 1000 }}
                      >
                        {renderDescriptionForDisplay(dataVal.Description)}
                      </p>

                      <br />
                    </div>
                  );
                })
              ) : bulletinarray &&
                viewbulletinsection &&
                showbulletinsectionentryform == false &&
                selectedentry ? (
                <div className="testname" style={{ paddingBottom: "35vh" }}>
                  <div>
                  <p
                    className="section5922abspace"
                    onClick={() => submmitChange(selectedentry)}
                    data-tooltip-id="my-tooltip-6"
                    onMouseEnter={() => setIsOpen6(true)}
                    onMouseLeave={() => setIsOpen6(false)}
                  >
                    ✅
                  </p>
                  {makeentryactivex == true ? (
                    <p
                      className="section5922abspace"
                      onClick={() => beginwiththis(selectedentry)}
                      data-tooltip-id="my-tooltip-18"
                      onMouseEnter={() => setIsOpen18(true)}
                      onMouseLeave={() => setIsOpen18(false)}
                    >
                      {" "}
                      ▶️{" "}
                    </p>
                  ) : null}

                  {makeentryactivex == false ? (
                    <p
                      className="section5922abspace"
                      onClick={() => beginwiththis2(selectedentry)}
                      data-tooltip-id="my-tooltip-"
                      onMouseEnter={() => setIsOpen19(true)}
                      onMouseLeave={() => setIsOpen19(false)}
                    >
                      🚫
                    </p>
                  ) : null}

                  <p
                    className="section5922abspace"
                    onClick={() => removeentry(selectedentry)}
                    data-tooltip-id="my-tooltip-24"
                    onMouseEnter={() => setIsOpen24(true)}
                    onMouseLeave={() => setIsOpen24(false)}
                  >
                    ❌
                  </p>
                  </div>

                  <div className="section591">
                    <textarea
                      placeholder="Title of Entry"
                      placeholdertextcolor="#BEBEBE"
                      value={localtitle} // ...force the input's value to match the state variable...
                      onChange={(e) => handleChange(e.target.value)}
                      type="text"
                      rows={1}
                      style={{
                        fontSize: "clamp(20px, 5vw, 50px)",
                        textAlign: "center",
                        color: "#fff",
                        alignContent: "center",
                        display: "inlineBlock",
                        margin: "10px",
                        marginBottom: "25px",
                        maxWidth: "835px",
                        fontWeight: "bold",
                      }}
                    />
                  </div>
                  <div
                    className="main2"
                    style={{
                      minHeight: newwidth * 0.2,
                      width: newwidth * 1.1,
                    }}
                  >
                    <div className="maina" style={{ width: newwidth / 1.2 }}>
                      {typeof nameofimg != "undefined" ? (
                        <div className="search4">
                          <div
                            className="search292"
                            onClick={() => handleClick2(localimg)}
                          >
                            Click to Add this file
                          </div>

                          <MediaRenderer
                            src={localimg}
                            fileName={nameofimg}
                            style={{ width: imagewidth }}
                            alt="Accepted Files: .png, .jpeg, .jpg, .webp, .mp4, .gif, .mov"
                          />
                        </div>
                      ) : (
                        <div>
                          {typeof localurl != "undefined" && localurl != "" ? (
                            <div>
                              <div
                                className="search2"
                                onClick={() => deleteimage27(localurl)}
                              >
                                Delete Image
                              </div>
                              <div className="imagecontainer12345">
                                <MediaRenderer
                                  src={localurl}
                                  fileName={localurl}
                                  alt="Accepted Files: .png, .jpeg, .jpg, .webp, .mp4, .gif, .mov" style={{ width: imagewidth }} />
                              </div>
                            </div>
                          ) : (
                            <>
                              <div className="search2">
                                Add a .png, .jpeg, .jpg .webp or .mp4, .gif
                              </div>
                              <input
                                type="file"
                                id="fileItem"
                                accept=".png,.jpeg,.jpg,.webp, .mp4, .gif, .mov"
                                onChange={(e) => setImg(e.target.files[0])}
                              />
                            </>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                  <div>
                    <p
                      className="section5922abspace"
                      onClick={() => addStudentname()}
                      data-tooltip-id="my-tooltip-8"
                      onMouseEnter={() => setIsOpen8(true)}
                      onMouseLeave={() => setIsOpen8(false)}
                    >
                      🧑‍🎓
                    </p>
                    <p
                      className="section5922abspace"
                      onClick={() => addLink("local")}
                      data-tooltip-id="my-tooltip-17"
                      onMouseEnter={() => setIsOpen17(true)}
                      onMouseLeave={() => setIsOpen17(false)}
                    >
                      🔗
                    </p>
                  </div>
                  <textarea
                    placeholder="Description of Entry"
                    placeholdertextcolor="#BEBEBE"
                    value={localdescription} // ...force the input's value to match the state variable...
                    onChange={(f) => handleChange2(f.target.value)}
                    type="text"
                    rows={
                      typeof localdescription != "undefined"
                        ? (localdescription.length / newwidth) * 16
                        : 5

                      // typeof localdescription != "undefined" &&
                      // (localdescription.length / width) * 16 > 2
                      //   ? (localdescription.length / width) * 16
                      //   : 5
                    }
                    style={{
                      fontSize: "20px",
                      textAlign: "center",
                      color: "#fff",
                      marginTop: "25px",

                      marginBottom: "45px",
                      alignSelf: "center",
                      alignContent: "center",

                      width: "80%",
                      minHeight: "250px"
                    }}
                  />
                </div>
              ) : null}

              {viewbulletinsection ==
                true ? null : showbulletinsectionentryform == true ? (
                  <div className="testname" style={{ paddingBottom: "35vh" }}>
                    <p
                      className="section5922abspace"
                      onClick={() => setShowbulletinsectionentryform(false)}
                      data-tooltip-id="my-tooltip-2"
                      onMouseEnter={() => setIsOpen2(true)}
                      onMouseLeave={() => setIsOpen2(false)}
                    >
                      ✅
                    </p>

                    <div className="section591">
                      <textarea
                        placeholder="Title of Entry"
                        placeholdertextcolor="#BEBEBE"
                        value={newtitletobesaved} // ...force the input's value to match the state variable...
                        onChange={(e) => handleChange3(e.target.value)}
                        type="text"
                        rows={1}
                        style={{
                          fontSize: "clamp(20px, 5vw, 50px)",
                          textAlign: "center",
                          color: "#fff",
                          alignContent: "center",
                          display: "inlineBlock",
                          margin: "10px",

                          maxWidth: "835px",
                          fontWeight: "bold",
                        }}
                      />
                    </div>
                    <div
                      className="main2"
                      style={{
                        minHeight: newwidth * 0.2,
                        width: newwidth * 1.1,
                      }}
                    >
                      <div className="maina" style={{ width: newwidth / 1.2 }}>

                        {typeof localimg4 != "undefined" ? (
                          <div className="search4">
                            <div
                              className="search292"
                              onClick={() => DhandleClick2()}
                            >
                              Click to Add this file
                            </div>
                            <MediaRenderer
                              src={localimg4}
                              fileName={nameofimg4}
                              style={{ width: imagewidth }}
                              alt="Accepted Files: .png, .jpeg, .jpg, .webp, .mp4, .gif, .mov"
                            />
                          </div>
                        ) : (
                          <div>
                            {typeof newphotostobesaved != "undefined" ? (
                              <div>
                                <div className="imagecontainer12345">
                                  <MediaRenderer
                                    src={newphotostobesaved}
                                    fileName={newphotostobesaved}
                                    alt="Accepted Files: .png, .jpeg, .jpg, .webp, .mp4, .gif, .mov"
                                    style={{ width: imagewidth }}
                                  />
                                </div>
                              </div>
                            ) : (
                              <>
                                <div className="search2">
                                  Add a .png, .jpeg, .jpg .webp or .mp4, .gif
                                </div>
                                <input
                                  type="file"
                                  id="fileItem"
                                  accept=".png,.jpeg,.jpg,.webp, .mp4, .gif, .mov"
                                  onChange={(e) => setImg4(e.target.files[0])}
                                />
                              </>
                            )}

                          </div>
                        )}
                      </div>
                    </div>
                    <div>
                      <p
                        className="section5922abspace"
                        onClick={() => addStudentnameToNewEntry()}
                        data-tooltip-id="my-tooltip-8"
                        onMouseEnter={() => setIsOpen8(true)}
                        onMouseLeave={() => setIsOpen8(false)}
                      >
                        🧑‍🎓
                      </p>
                      <p
                        className="section5922abspace"
                        onClick={() => addLinkToNewEntry("new")}
                        data-tooltip-id="my-tooltip-17"
                        onMouseEnter={() => setIsOpen17(true)}
                        onMouseLeave={() => setIsOpen17(false)}
                      >
                        🔗
                      </p>
                    </div>
                    <textarea
                      placehdolder="Description of Entry"
                      placeholdertextcolor="#BEBEBE"
                      value={newdescriptiontobesaved} // ...force the input's value to match the state variable...
                      onChange={(f) => handleChange4(f.target.value)}
                      type="text"
                      rows={
                        typeof newdescriptiontobesaved != "undefined"
                          ? (newdescriptiontobesaved.length / newwidth) * 16
                          : 5

                        // typeof localdescription != "undefined" &&
                        // (localdescription.length / width) * 16 > 2
                        //   ? (localdescription.length / width) * 16
                        //   : 5
                      }
                      style={{
                        fontSize: "20px",
                        textAlign: "center",
                        color: "#fff",
                        marginTop: "25px",

                        marginBottom: "45px",
                        alignSelf: "center",
                        alignContent: "center",

                        width: "80%",

                      minHeight: "250px"
                      }}
                    />
                  </div>
                ) : null}
            </header>
          </div>
        ) : language == "en" ? (
          <div className="App" style={{ maxWidth: newwidth }}>
            <header className="App-header">

              <br />

              {bulletinarray &&
                bulletinarray.map((dataVal, i) => {
                  return (
                    <>
                      {dataVal.makeentryactive == true ? (
                        <div key={i}>
                          <p className="section5922abicon">📌</p>
                          <div className="section591">
                            <p className="section5922a2345atry">
                              {dataVal.Title}
                            </p>
                          </div>

                          {typeof dataVal.url != "undefined" &&
                            dataVal.url != "" ? (
                            <div
                              style={{
                                transformOrigin: "0 0",
                                width: width,
                              }}
                            >
                              {isVideoUrl(dataVal.url) ? (
                                <MediaRenderer
                                  src={dataVal.url}
                                  fileName={dataVal.url}
                                  style={{ width: width > 500 ? "65%" : "80%" }}
                                  alt="video"
                                />
                              ) : (
                                <a href={dataVal.url} download>
                                  <MediaRenderer
                                    src={dataVal.url}
                                    fileName={dataVal.url}
                                    style={{ width: width > 500 ? "65%" : "80%" }}
                                    alt="image"
                                  />
                                </a>
                              )}
                            </div>
                          ) : null}

                          <div
                            style={{ transformOrigin: "0 0", width: "100%" }}
                          >
                            <p className="section5922a2345abut">
                              {renderDescriptionForDisplay(dataVal.Description)}
                            </p>
                          </div>
                          <br />
                        </div>
                      ) : null}
                    </>
                  );
                })}
            </header>
          </div>
        ) : (
          <div className="App" style={{ maxWidth: newwidth }}>
            <header className="App-header">
              <br />

              {Array.isArray(filtereddata) &&
                filtereddata.map((dataVal, i) => {
                  return (
                    <>
                      {dataVal.makeentryactive == true ? (
                        <div key={i}>
                          <p className="section5922abicon">📌</p>
                          <div className="section591">
                            <p className="section5922a2345atry">
                              {/* {getnewlanguaage5(dataVal.Title)} */}
                              {/* {getnewlanguaage5("Hello")}  */}

                              {renderDescriptionForDisplay(i == 0
                                ? text50
                                : i == 1
                                  ? text51
                                  : i == 2
                                    ? text52
                                    : i == 3
                                      ? text53
                                      : i == 4
                                        ? text54
                                        : i == 5
                                          ? text55
                                          : i == 6
                                            ? text56
                                            : i == 7
                                              ? text57
                                              : i == 8
                                                ? text58
                                                : i == 9
                                                  ? text59
                                                  : null)}
                            </p>
                          </div>


                          {typeof dataVal.url != "undefined" &&
                            dataVal.url != "" ? (
                            <div
                              style={{
                                transformOrigin: "0 0",
                                width: width,
                              }}
                            >
                              {isVideoUrl(dataVal.url) ? (
                                <MediaRenderer
                                  src={dataVal.url}
                                  fileName={dataVal.url}
                                  style={{ width: width > 500 ? "65%" : "80%" }}
                                  alt="video"
                                />
                              ) : (
                                <a href={dataVal.url} download>
                                  <MediaRenderer
                                    src={dataVal.url}
                                    fileName={dataVal.url}
                                    style={{ width: width > 500 ? "65%" : "80%" }}
                                    alt="image"
                                  />
                                </a>
                              )}
                            </div>
                          ) : null}

                          <div
                            style={{ transformOrigin: "0 0", width: "100%" }}
                          >
                            <p className="section5922a2345abut">
                              {renderDescriptionForDisplay(i == 0
                                ? text60
                                : i == 1
                                  ? text61
                                  : i == 2
                                    ? text62
                                    : i == 3
                                      ? text63
                                      : i == 4
                                        ? text64
                                        : i == 5
                                          ? text65
                                          : i == 6
                                            ? text66
                                            : i == 7
                                              ? text67
                                              : i == 8
                                                ? text68
                                                : i == 9
                                                  ? text69
                                                  : null)}
                            </p>
                          </div>
                          <br />
                          <br />
                        </div>
                      ) : null}
                    </>
                  );
                })}
            </header>
          </div>
        )}
      </div>


      {isLinkModalOpen && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.6)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
          }}
          onClick={() => setIsLinkModalOpen(false)}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              background: "#222",
              color: "#fff",
              padding: 20,
              borderRadius: 8,
              width: "min(720px, 90%)",
            }}
          >
            <h3 style={{ marginTop: 0 }}>Add Hyperlink</h3>
            <div style={{ marginBottom: 10 }}>
              <label style={{ display: "block", marginBottom: 6 }}>Link text</label>
              <input
                value={linkFrontText}
                onChange={(e) => setLinkFrontText(e.target.value)}
                placeholder="What should users see (e.g. 'More info')"
                style={{ width: "100%", padding: 8, borderRadius: 4 }}
              />
            </div>
            <div style={{ marginBottom: 10 }}>
              <label style={{ display: "block", marginBottom: 6 }}>URL</label>
              <input
                value={linkHref}
                onChange={(e) => setLinkHref(e.target.value)}
                placeholder="https://example.com"
                style={{ width: "100%", padding: 8, borderRadius: 4 }}
              />
            </div>
            <div style={{ display: "flex", gap: 8, justifyContent: "flex-end" }}>
              <button
                onClick={() => setIsLinkModalOpen(false)}
                style={{ padding: "8px 12px", background: "#444", color: "#fff", border: "none", borderRadius: 4 }}
              >
                Cancel
              </button>
              <button
                onClick={saveLinkToDescription}
                style={{ padding: "8px 12px", background: "#0a84ff", color: "#fff", border: "none", borderRadius: 4 }}
              >
                Insert Link
              </button>
            </div>
          </div>
        </div>
      )}
      <ReactTooltip
        id="my-tooltip-1"
        place="bottom"
        content="Add New Bulletin Item"
        isOpen={isOpen1}
        style={{ color: "orange", fontSize: "25px" }}
      />
      <ReactTooltip
        id="my-tooltip-2"
        place="bottom"
        content="Press To Save And View Entry"
        isOpen={isOpen2}
        style={{ color: "orange", fontSize: "25px" }}
      />
      <ReactTooltip
        id="my-tooltip-3"
        place="bottom"
        content="Press To Edit Section"
        isOpen={isOpen3}
        style={{ color: "orange", fontSize: "25px" }}
      />

      <ReactTooltip
        id="my-tooltip-3b"
        place="bottom"
        content="Press To Edit Section"
        isOpen={isOpen3b}
        style={{ color: "orange", fontSize: "25px" }}
      />
      <ReactTooltip
        id="my-tooltip-5"
        place="bottom"
        content="Press To Save & View Section"
        isOpen={isOpen5}
        style={{ color: "orange", fontSize: "25px" }}
      />

      <ReactTooltip
        id="my-tooltip-5b"
        place="bottom"
        content="Press To Save & View Section"
        isOpen={isOpen5b}
        style={{ color: "orange", fontSize: "25px" }}
      />
      <ReactTooltip
        id="my-tooltip-4"
        place="bottom"
        content="Press To Edit Entry"
        isOpen={isOpen4}
        style={{ color: "orange", fontSize: "25px" }}
      />

      <ReactTooltip
        id="my-tooltip-6"
        place="bottom"
        content="Press To Save & View Section"
        isOpen={isOpen6}
        style={{ color: "orange", fontSize: "25px" }}
      />

      <ReactTooltip
        id="my-tooltip-8"
        place="bottom"
        content="Add Student Name To End Of Current Text"
        isOpen={isOpen8}
        style={{ color: "orange", fontSize: "25px" }}
      />

      <ReactTooltip
        id="my-tooltip-9"
        place="bottom"
        content="Students Can Submit Photo Descriptions Of This Class"
        isOpen={isOpen9}
        style={{ color: "orange", fontSize: "25px" }}
      />
      <ReactTooltip
        id="my-tooltip-10"
        place="bottom"
        content="Students can NOT submit Photo Descriptions of you (the teacher)"
        isOpen={isOpen10}
        style={{ color: "orange", fontSize: "25px" }}
      />
      <ReactTooltip
        id="my-tooltip-11"
        place="bottom"
        content="Students can submit Photo Descriptions of you (the teacher)"
        isOpen={isOpen11}
        style={{ color: "orange", fontSize: "25px" }}
      />

      <ReactTooltip
        id="my-tooltip-12"
        place="bottom"
        content="Show This Section's Teacher Submitted Photo To Parents"
        isOpen={isOpen12}
        style={{ color: "orange", fontSize: "25px" }}
      />
      <ReactTooltip
        id="my-tooltip-13"
        place="bottom"
        content="Approved Student Photos Will Only Be Presented To Their Own Parents"
        isOpen={isOpen13}
        style={{ color: "orange", fontSize: "25px" }}
      />
      <ReactTooltip
        id="my-tooltip-14"
        place="bottom"
        content="Approved Student Photos Will Be Presented To All Parents"
        isOpen={isOpen14}
        style={{ color: "orange", fontSize: "25px" }}
      />

      <ReactTooltip
        id="my-tooltip-15"
        place="bottom"
        content="Show This Section's Teacher Submitted Photo To Parents"
        isOpen={isOpen15}
        style={{ color: "orange", fontSize: "25px" }}
      />
      <ReactTooltip
        id="my-tooltip-16"
        place="bottom"
        content="Approved Student Photos Will Only Be Presented To Their Own Parents"
        isOpen={isOpen16}
        style={{ color: "orange", fontSize: "25px" }}
      />
      <ReactTooltip
        id="my-tooltip-17"
        place="bottom"
        content="Add Link To End Of Current Text"
        isOpen={isOpen17}
        style={{ color: "orange", fontSize: "25px" }}
      />
      <ReactTooltip
        id="my-tooltip-18"
        place="bottom"
        content="This Bulletin Entry Will Be Seen By Parents"
        isOpen={isOpen18}
        style={{ color: "orange", fontSize: "25px" }}
      />
      <ReactTooltip
        id="my-tooltip-19"
        place="bottom"
        content="This Bulletin Entry Will NOT Be Seen By Parents"
        isOpen={isOpen19}
        style={{ color: "orange", fontSize: "25px" }}
      />

      <ReactTooltip
        id="my-tooltip-20"
        place="bottom"
        content="This Teacher Section Will Be Seen By Parents"
        isOpen={isOpen20}
        style={{ color: "orange", fontSize: "25px" }}
      />
      <ReactTooltip
        id="my-tooltip-21"
        place="bottom"
        content="This Teacher Section Will NOT Be Seen By Parents"
        isOpen={isOpen21}
        style={{ color: "orange", fontSize: "25px" }}
      />
      <ReactTooltip
        id="my-tooltip-22"
        place="bottom"
        content="This Class Section Will Be Seen By Parents"
        isOpen={isOpen22}
        style={{ color: "orange", fontSize: "25px" }}
      />
      <ReactTooltip
        id="my-tooltip-23"
        place="bottom"
        content="This Class Section Will NOT Be Seen By Parents"
        isOpen={isOpen23}
        style={{ color: "orange", fontSize: "25px" }}
      />
      <ReactTooltip
        id="my-tooltip-24"
        place="bottom"
        content="Permanently Delete Entry"
        isOpen={isOpen24}
        style={{ color: "orange", fontSize: "25px" }}
      />

      <ReactTooltip
        id="my-tooltip-25"
        place="bottom"
        content="Add To All Of My Classes"
        isOpen={isOpen25}
        style={{ color: "orange", fontSize: "25px" }}
      />
    </>
  );
}

export default App;